import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './styles/ThemeProvider';
import { GlobalStyles } from './styles/GlobalStyles';
import reportWebVitals from './reportWebVitals';

declare global {
  interface Window {
    __nonce__?: string;
  }

  // eslint-disable-next-line no-var
  var __webpack_nonce__: string | undefined;
}

const metaNonce = document
  .querySelector('meta[name="csp-nonce"]')
  ?.getAttribute('content');

if (metaNonce) {
  window.__nonce__ = metaNonce;
  __webpack_nonce__ = metaNonce;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <GlobalStyles />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
